export const baseFeatures = {
  affiliazioni: true,
  calendari: true,
  classifiche: true,
  gironi: true,
  iscrizioni: true,
  spostamenti: true,
  squadre: true,
}

export const extraFeatures = {
  algoritmi: true,
  arbitraggi: true,
  arbitri: true,
  corsi: true,
  designazioni: true,
  distinte: true,
  provvedimenti: true,
  rendiconti: true,
  rimborsi: true,
  tabelloni: true,
  tesserati: true,
}
